import React, {useEffect, useState} from 'react';
import {TreeGenome} from "./Tree";
import {Loads} from "../../../services/interface/query/loads";
import {SupervisedUserCircleTwoTone} from "@mui/icons-material";
import AdditionalFamily from "./AdditionalFamily";
import {Person} from "../../../services/interface/query/person";
import {GenomeInterface} from "../../../services/interface/query/genome-interface";
import {Skeleton} from "../../../components/general/Skeleton";
import {useTranslation} from "react-i18next";
import {useFindPersonGenome} from "../../../services/apis/apiGenomePerson";
import NotPermissionComponent from "../NotPermissionComponent";

interface Props {
    person?: Person;
    setValue?: React.Dispatch<React.SetStateAction<number>>;
}

export function Genome({person, setValue}: Props) {
    const {t} = useTranslation("global") as { t: (key: string) => string };

    const {
        mutate: getPersonGenome,
        isPending: loadingPersonGenome,
        isError,
        error: errorPersonGenome,
        data: successPersonGenome
    } = useFindPersonGenome()

    const [dataHeader, setDataHeader] = React.useState<Loads[] | undefined>()
    const [personGenome, setPersonGenome] = useState<GenomeInterface | undefined>();

    useEffect(() => {
        if (person && person.identification) {
            setPersonGenome(undefined)
            getPersonGenome({identifier: person.identification, msj: t('genome')})
        }
    }, [person]);

    useEffect(() => {
        if (successPersonGenome) {
            setDataHeader([
                {description: t('loads'), value: successPersonGenome?.numFamilyResp},
                {description: t('siblings'), value: successPersonGenome?.numSiblings},
                {description: t('children'), value: successPersonGenome?.numChildren},
            ])
            setPersonGenome(successPersonGenome)
        }
    }, [successPersonGenome]);

    useEffect(() => {
        if (isError) {
            setPersonGenome(undefined)
        }
    }, [isError]);

    function getLoad(item: Loads, index: number) {
        return (
            <div key={index} className={'flex flex-row gap-1 items-center'}>
                <SupervisedUserCircleTwoTone/>
                <span className={'text-[16px]'}>{`${item.description}: `}</span>
                <span className={'text-[20px] font-semibold'}>{item.value}</span>
            </div>
        )
    }

    return (
        <div className={'flex flex-col gap-3'}>
            {loadingPersonGenome && <h3 className={'-mb-3'}>{t('genome')}</h3>}
            <NotPermissionComponent
                title={'/information/genome'}
                loading={loadingPersonGenome}
                error={errorPersonGenome}
                component={
                    <>
                        <>
                            <div className={'flex flex-col sm:flex-row sm:gap-6'}>
                                {dataHeader && dataHeader.length > 0 && dataHeader.map((item, index) => getLoad(item, index))}
                            </div>
                            {loadingPersonGenome && !personGenome &&
                                <Skeleton className={'min-h-[400px]'}/>
                            }
                            <h3 className={'-mb-3'}>{t('genome')}</h3>
                            {person && personGenome && !loadingPersonGenome &&
                                <TreeGenome person={personGenome} {...{setValue}}/>
                            }
                        </>
                    </>
                }
            />
            <AdditionalFamily {...{person}}/>
        </div>
    );
}
